import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getAirwaySelector } from '../selectors'
import { AirwayConstants } from '../store/airway.constants'
import { IAirwayState } from '../store/airway.types'

export function* setProcedureComplications() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const airwayState: IAirwayState = yield select(getAirwaySelector)
  const { inputRows } = procedureState
  const { procedureComplications } = airwayState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === AirwayConstants.SET_PROCEDURE_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = procedureComplications
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setProcedureComplicationsSaga() {
  yield takeLatest([AirwayConstants.SET_PROCEDURE_COMPLICATIONS], setProcedureComplications)
}
